import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const PatientStatus = ({ patientInfo }) => {
  const delayedDate = patientInfo?.delayed_activation_date;
  const isActive = patientInfo?.active && !patientInfo?.on_hold;
  const isDelayed = isActive && delayedDate && moment(delayedDate).isAfter(moment(), "day");

  return (
    <div className={`patient-status-bar ${patientInfo?.active ? patientInfo?.on_hold ? "patient-on-hold" : "patient-active" : "patient-inactive"}`}>
      <h6 className='general-status-container'>{patientInfo?.active ? patientInfo?.on_hold ? "On Hold" : "Active" : "Inactive"}</h6>
      {isDelayed && (
        <p className='delayed-status-message'>
          Patient is in delayed status until {moment(delayedDate).format("ll")}.
        </p>
      )}
    </div>
  );
};

PatientStatus.propTypes = {
  patientInfo: PropTypes.object.isRequired
};

export default PatientStatus;
